module.exports = __webpack_public_path__ + "static/media/spirited.3479dd18.jpg";